/** @format */
import type { DatePickType } from 'element-plus';

interface TimeType {
	label: string;
	format: string;
	type: DatePickType | 'time';
}

export const timeTypeList: TimeType[] = [
	{
		label: '年-月-日 时:分:秒',
		format: 'YYYY-MM-DD HH:mm:ss',
		type: 'datetime',
	},
	{
		label: '年-月-日 时:分',
		format: 'YYYY-MM-DD HH:mm',
		type: 'datetime',
	},
	{
		label: '年-月-日 时',
		format: 'YYYY-MM-DD HH',
		type: 'datetime',
	},
	{
		label: '年-月-日',
		format: 'YYYY-MM-DD',
		type: 'date',
	},
	{
		label: '年-月',
		format: 'YYYY-MM',
		type: 'month',
	},
	{
		label: '年',
		format: 'YYYY',
		type: 'year',
	},
	{
		label: '时:分:秒',
		format: 'HH:mm:ss',
		type: 'time',
	},
	{
		label: '时:分',
		format: 'HH:mm',
		type: 'time',
	},
];

// 人员字段
export const userLink = [
	{
		label: '姓名',
		value: 'name',
	},
	{
		label: '用户id',
		value: 'id',
	},
	{
		label: '账号',
		value: 'account',
	},
	{
		label: '部门',
		value: 'orgName',
	},
	{
		label: '邮箱',
		value: 'email',
	},
	{
		label: '电话',
		value: 'mobile',
	},
];

// 部门字段
export const deptLink = [
	{
		label: '部门名称',
		value: 'name',
	},
	{
		label: '部门id',
		value: 'id',
	},
];

// 角色字段
export const roleLink = [
	{
		label: '角色名称',
		value: 'roleName',
	},
	{
		label: '角色id',
		value: 'roleId',
	},
	{
		label: '权限字符',
		value: 'roleKey',
	},
];

// 模型引用字段
export const modelLink = [
	{
		label: '数据id',
		value: 'objectid',
	},
];

export const getLinkList = (type) => {
	switch (type) {
		case 'user':
			return userLink;
		case 'department':
			return deptLink;
		case 'role':
			return roleLink;
		case 'modelLink':
			return modelLink;
		default:
			return userLink;
	}
};

export enum paramsTypeEnum {
	人工 = '0',
	引用 = '1',
	业务对象 = '2',
}

export enum desensitizeEnum {
	/** 自定义 */
	custom = 1,
	/** 全量 */
	all,
	/** 部分 */
	part,
}

export const desensitizeList = [
	{
		type: desensitizeEnum.all,
		label: '全量',
	},
	{
		type: desensitizeEnum.part,
		label: '部分',
	},
	{
		type: desensitizeEnum.custom,
		label: '自定义',
	},
];
